import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { SingleImportUpdateModel } from 'src/app/core/models/manualUpdates/single-import';
import { AddSingleManualUpdateComponent } from '../add-single-manual-update/add-single-manual-update.component';
import { BulkImportManualUpdateComponent } from '../bulk-import-manual-update/bulk-import-manual-update.component';
@Component({
  selector: 'app-add-manual-update',
  templateUrl: './add-manual-update.component.html',
  styleUrls: ['./add-manual-update.component.scss'],
})
export class AddManualUpdateComponent implements OnInit {
  saveButtonText!: string;
  @ViewChild('staticTabs', { static: false }) staticTabs?: TabsetComponent;
  constructor(
    @Inject(MAT_DIALOG_DATA) public id:string, 
  public dialogRef: MatDialogRef<AddManualUpdateComponent>) {
  }
  @ViewChild(AddSingleManualUpdateComponent)
  childSingle!: AddSingleManualUpdateComponent;
  @ViewChild(BulkImportManualUpdateComponent)
  childBulk!: BulkImportManualUpdateComponent;
  isSingle:boolean=true;
  isShowErrorMessage:boolean=false;
  ngOnInit(): void {
    if(this.id){
      this.saveButtonText="Update";
    }
    else{
      this.saveButtonText="Save";
    }
  }
  selectTab(tabId: number) {
    if (this.staticTabs?.tabs[tabId]) {
      this.staticTabs.tabs[tabId].active = true;
    }
  }
 async Save(){
   if(this.isSingle){
    let result=await this.childSingle.SaveUpdate();
    if(result==="Valid"){
      this.dialogRef.close("Valid");
    }
   }
   else{
    let result=await this.childBulk.SaveUpdates();
    if(result==="Valid"){
      this.dialogRef.close("Valid");
    }
   }
  }
  tabSelection(event:string){
    this.isSingle=(event==="single")?true:false;
    if(event=="single"){
      this.isShowErrorMessage=false;
    }
  }
  addItem(newItem: boolean) {
    this.isShowErrorMessage=newItem;
  }

}
